/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetOwnClaimRequest
 */
export interface AssetOwnClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    debtorName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    debtorAddress: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimRequest
     */
    isRelated: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    relationship: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    legalReason: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetOwnClaimRequest
     */
    amount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetOwnClaimRequest
     */
    dueDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimRequest
     */
    isSecured: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    securities: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimRequest
     */
    isDisputed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimRequest
     */
    hasPendingCourtProceedings: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    disputeDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimRequest
     */
    isCollectible: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimRequest
     */
    collectionSteps: string | null;
}

/**
 * Check if a given object implements the AssetOwnClaimRequest interface.
 */
export function instanceOfAssetOwnClaimRequest(value: object): value is AssetOwnClaimRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('debtorName' in value) || value['debtorName'] === undefined) return false;
    if (!('debtorAddress' in value) || value['debtorAddress'] === undefined) return false;
    if (!('isRelated' in value) || value['isRelated'] === undefined) return false;
    if (!('relationship' in value) || value['relationship'] === undefined) return false;
    if (!('legalReason' in value) || value['legalReason'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('isSecured' in value) || value['isSecured'] === undefined) return false;
    if (!('securities' in value) || value['securities'] === undefined) return false;
    if (!('isDisputed' in value) || value['isDisputed'] === undefined) return false;
    if (!('hasPendingCourtProceedings' in value) || value['hasPendingCourtProceedings'] === undefined) return false;
    if (!('disputeDetails' in value) || value['disputeDetails'] === undefined) return false;
    if (!('isCollectible' in value) || value['isCollectible'] === undefined) return false;
    if (!('collectionSteps' in value) || value['collectionSteps'] === undefined) return false;
    return true;
}

export function AssetOwnClaimRequestFromJSON(json: any): AssetOwnClaimRequest {
    return AssetOwnClaimRequestFromJSONTyped(json, false);
}

export function AssetOwnClaimRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetOwnClaimRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'debtorName': json['debtorName'],
        'debtorAddress': json['debtorAddress'],
        'isRelated': json['isRelated'],
        'relationship': json['relationship'],
        'legalReason': json['legalReason'],
        'amount': json['amount'],
        'dueDate': (json['dueDate'] == null ? null : new Date(json['dueDate'])),
        'isSecured': json['isSecured'],
        'securities': json['securities'],
        'isDisputed': json['isDisputed'],
        'hasPendingCourtProceedings': json['hasPendingCourtProceedings'],
        'disputeDetails': json['disputeDetails'],
        'isCollectible': json['isCollectible'],
        'collectionSteps': json['collectionSteps'],
    };
}

export function AssetOwnClaimRequestToJSON(json: any): AssetOwnClaimRequest {
    return AssetOwnClaimRequestToJSONTyped(json, false);
}

export function AssetOwnClaimRequestToJSONTyped(value?: AssetOwnClaimRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'debtorName': value['debtorName'],
        'debtorAddress': value['debtorAddress'],
        'isRelated': value['isRelated'],
        'relationship': value['relationship'],
        'legalReason': value['legalReason'],
        'amount': value['amount'],
        'dueDate': value['dueDate'] == null ? value['dueDate'] : `${value['dueDate'].getFullYear()}-${String(value['dueDate'].getMonth()+1).padStart(2,'0')}-${String(value['dueDate'].getDate()).padStart(2,'0')}`,
        'isSecured': value['isSecured'],
        'securities': value['securities'],
        'isDisputed': value['isDisputed'],
        'hasPendingCourtProceedings': value['hasPendingCourtProceedings'],
        'disputeDetails': value['disputeDetails'],
        'isCollectible': value['isCollectible'],
        'collectionSteps': value['collectionSteps'],
    };
}

